// extracted by mini-css-extract-plugin
module.exports = {"corrected-search-term":"CorrectedSearchTerm_corrected-search-term__S3BfA","corrected-search-term__copy":"CorrectedSearchTerm_corrected-search-term__copy__Uw_6g"};